"use strict";var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;exports.__esModule = true;exports.LightTheme5_2 = void 0;var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));var _ThemeHelpers = require("../../lib/theming/ThemeHelpers");

var _BasicTheme = require("./BasicTheme");
var _LightTheme5_2 = require("./LightTheme5_1");var _LightTheme5_;

var LightTheme5_2 = exports.LightTheme5_2 = (0, _ThemeHelpers.createTheme)({
  themeClass: (_LightTheme5_ = /*#__PURE__*/function (_BasicThemeClassForEx) {function LightTheme5_2() {return _BasicThemeClassForEx.apply(this, arguments) || this;}(0, _inheritsLoose2.default)(LightTheme5_2, _BasicThemeClassForEx);return (0, _createClass2.default)(LightTheme5_2, null, [{ key: "mobileModalCloseButtonRightPadding", get:
      function get() {
        return this.mobileModalCloseButtonClickArea;
      } }, { key: "mobileModalCloseButtonTopPadding", get:
      function get() {
        return this.mobileModalCloseButtonClickArea;
      } }]);}(_BasicTheme.BasicThemeClassForExtension), _LightTheme5_.
  mobileModalCloseButtonClickArea = '22px', _LightTheme5_.
  mobileModalBodyPadding = '0 16px 0 16px', _LightTheme5_.
  mobileModalContainerMarginTop = '16px', _LightTheme5_.
  mobileModalContainerMarginRight = '16px', _LightTheme5_.
  mobileModalContainerMarginBottom = '16px', _LightTheme5_.
  mobileModalContainerMarginLeft = '16px', _LightTheme5_.

  miniModalMarginTopMobile = '16px', _LightTheme5_.
  miniModalMarginLeftMobile = '16px', _LightTheme5_.
  miniModalMarginRightMobile = '16px', _LightTheme5_),

  prototypeTheme: _LightTheme5_2.LightTheme5_1,
  themeMarkers: [(0, _ThemeHelpers.markThemeVersion)('5.2')]
});